import { AnonymousErrorCodesLookup } from '~/common/helpers';
import { useErrorTranslation } from '~/common/hooks';

export const useAnonymousErrorTranslation = () =>
  useErrorTranslation(AnonymousErrorCodesLookup);
